<template>
  <v-app-bar color="primary" dark>
    <v-toolbar-title class="headline text-center">
      {{ title }} ({{ sequence.current }}/{{ sequence.total }}) - {{ category }}
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Title Here...'
    },
    category: {
      type: String,
      default: 'Warmup'
    },
    sequence: {
      type: Object,
      default: () => ({ current: 1, total: 7 })
    }
  }
}
</script>
